export function stripHtml(value) {
  let regex = /(<([^>]+)>)/gi
  return value.replace(regex, '')
}
